import { engineRequest } from './http';

export const listSlaTiers = () => engineRequest({ path: '/sla/tiers' });

export const putSlaTier = (tier, fields) =>
  engineRequest({ method: 'put', path: `/sla/tiers/${tier}`, data: fields });
